<template lang="pug">
  .table-responsive
    table#tbAceptarItems.table.is-striped.is-fullwidth
      thead
        tr
          th Categoría(s)
          th Enviado(s)
          th(v-show="parseInt(salida.estado) > 1")
            | Recibido(s)
          th
          th Observación
          th
      tbody
        tr(v-for="(data, index) in items" :key="data.id")
          td  
            span(v-html="getCats(data)")
          td 
            span.tag.is-black
              | {{ getCantidadEnv(data)}}
          td(v-show="verInputCantRec")
            .field
              .control
                input.input.is-primary(
                  type='number', 
                  step="0.1"
                  :placeholder="getCantidadRec(data)",
                  min='0'
                  :max="getCantidadEnv(data)"
                  :value="getDataAceptada(data)"
                  ref="input_recibidos"
                  @change='checkMax(data, index)'
                )
          td(v-show="verInputCantRec")
            a.button.is-black.is-small.is-rounded(
              @click="aceptarItems(data, index)"
              ref="buttonAceptar"
            )
              i.fas.fa-save
            | &nbsp
            a.button.is-light.is-small.is-rounded(@click="cancelarEditarCantRecibida(index)")
              span.icon
                i.fas.fa-times
          td(v-show="!verInputCantRec")
            span.tag.is-black
              | {{ getCantidadRec(data) }}
            | &nbsp
            a.button.is-warning.is-small.is-rounded(@click="editarCantRecibida(index)")
              span.icon
                i.fas.fa-pencil-alt
            
          td(v-show="verInputObservaciones")
            .fields
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Observaciones',
                  :value="getObservacion(data)"
                  ref="input_observaciones"
                )
          td(v-show="verInputObservaciones")
            a.button.is-black.is-small.is-rounded(
              @click="updateObservacion(data, index)"
              ref="buttonUpdate"
            )
              i.fas.fa-save
          td(v-show="!verInputObservaciones")
            span.tag.is-black
              | {{ getObservacion(data) }}
</template>

<script>
  export default {
    name: 'TbAceptarItemsAasignacionCons',
    props: {
      items: {
        type: Array,
        default: []
      },
      salida: {
        type: Object,
        default: ()=> {}
      }
    },
    data() {
      return {
        verEditar: false,
        verInputCantRec: false,
        verInputObservaciones: false,
      }
    },
    methods: {
      getCats(data) {
        let htmlStr = ''

        if (data.subcategoria === '') {
          htmlStr = `<span class="tag is-warning">${data.categoria}</span>`
        } else {
          htmlStr = `<div class="control">
            <div class="tags has-addons">
              <span class="tag is-black">
                <i class="fas fa-tag"></i>&nbsp ${data.categoria}
              </span>
              <span class="tag is-warning"> ${data.subcategoria}
              </span>
            </div>
          </div>`
        }
        return htmlStr
      },
      aceptarItems(data, index) {
        const button = this.$refs.buttonAceptar[index]
        const isDisabled = button.getAttribute('disabled') ? button.getAttribute('disabled') : false
        if (!isDisabled) {
          let cantRecibida = this.$refs.input_recibidos[index].value
          button.setAttribute('disabled', true)
          let myObj = {
            id: data.id,
            idAS: data.id_salida,
            categoria: data.categoria, 
            subcategoria: data.subcategoria, 
            cantRecibida: cantRecibida,
            itemEstado: data.estado, 
          }
          this.$emit('saveItem', myObj)
        } else {
          console.log('disabled')
        }
      },

      updateObservacion(data, index) {
        let observacion =  this.$refs.input_observaciones[index].value
        let button = this.$refs.buttonUpdate[index]
        let myObj = {
          id: data.id,
          idAS: data.id_salida,
          categoria: data.categoria, 
          subcategoria: data.subcategoria, 
          observacion: observacion,
          itemEstado: data.estado, 
        }
        this.$emit('saveObs', myObj)
      },

      saveObservaciones(e, data) {
        let myObj = {
          id: data.id,
          idAS: data.idArt_Salida,
          categoria: data.categoria, 
          subcategoria: data.subcategoria, 
          observacion: e.target.value
        }
        this.verEditar = true
        this.$emit('saveObservacion', myObj)
      },
      editarObservacion (index) {
        const button = this.$refs.buttonAceptar[index]
        button.getAttribute('disabled') ? button.getAttribute('disabled') : false
        this.verInputObservaciones = true
      },
      eliminarObservacion (data) {
        let myObj = {
          id: data.id,
          idAS: data.idArt_Salida,
          categoria: data.categoria, 
          subcategoria: data.subcategoria, 
        }
        this.$emit('deleteObservacion', myObj)
      },

      getObservacion (item) {
        let obser = false
        switch (parseInt(this.salida.estado)) {
          case 0:
              obser = item.o_entrega
            break
          case 1:
            obser = item.o_entrega
            break
          case 2:
            if (item.o_recibe === '') {
              obser = item.o_entrega
            } else {
              obser = item.o_recibe
            }
            break
          default:
            obser = ''
            break
        }
        return obser
      },

      getCantidadEnv (data) {
        let result = 0
        switch (this.salida.estado) {
          case 0:
            result = data.cantidad_e
            break
          case 1:
            result = data.cantidad_e
            break
          case 2:
            result = data.cantidad_e
            break
          default:
            result = 0
            break
        }
        return result
      },

      getCantidadRec (data) {
        let result = 0
        switch (this.salida.estado) {
          case 0:
            result = data.cantidad_e
            break
          case 1:
            result = data.cantidad_e
            break
          case 2:
            result = data.cantidad_r
            break
          default:
            result = 0
            break
        }
        return result
      },

      showIfSigned () {
        let mostrarTag = false
        if (this.salida.estado > 0) {
          ( this.salida.firma_recibe.length > 0 ) ? mostrarTag = false : mostrarTag = true
        } else {
          mostrarTag = false
        }
        this.verInputCantRec = mostrarTag
        this.verInputObservaciones = mostrarTag
      },
      checkMax (data, index) {
        let cantRecibida = this.$refs.input_recibidos[index].value

        let maximo = 0
        switch (this.salida.estado) {
          case 0:
            maximo = Number(data.cantidad_e)
            break
          case 1:
            maximo = Number(data.cantidad_e)
            break
          case 2:
            maximo = Number(data.cantidad_e)
            break
          default:
            maximo = 0
            break
        }
        if (cantRecibida > maximo) {
          this.$refs.input_recibidos[index].value = maximo
        } else {
        }
      },
      getDataAceptada (data) {
        let recibe
        switch (this.salida.estado) {
          case 1:
            recibe = (data.firma_entrega !== '' && data.cantidad_e == 0) ?  1 : data.cantidad_e
            break
          case 2:
            recibe = (data.firma_recibe !== '' && data.cantidad_r == 0) ?  1 : data.cantidad_r
            break
          default:
            recibe = 1
            break
        }
        return recibe
      },

      editarCantRecibida (index) {
        const button = this.$refs.buttonAceptar[index]
        button.removeAttribute('disabled')
        this.verInputCantRec = true
      },

      cancelarEditarCantRecibida (index) {
        const button = this.$refs.buttonAceptar[index]
        button.setAttribute('disabled', true)
        this.verInputCantRec = false
      },
    },
    created () {
      this.showIfSigned()
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/inventario_Componentes/TbAceptarItemsAsignacionCons.vue